import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-career-projects',
  templateUrl: './career-projects.component.html',
  styleUrls: ['./career-projects.component.css']
})
export class CareerProjectsComponent implements OnInit {

  category: any;

  constructor(
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.url.subscribe(url => {
      this.category = url;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/career/career-projects/career-projects.component.ts